var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sub-wrap"},[_c('CourseMaterials',{attrs:{"class-type-id":_vm.classTypeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }